"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var SelectList = /** @class */ (function () {
    function SelectList(rootElement) {
        var _this = this;
        this.rootElement = rootElement;
        this.selectOrDeselectItemsWithInput();
        // Add active modifier
        eventsHelper_1.default.live('.o-select-list__item', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            _this.selectOrDeselectItemsWithInput(clickedElement);
        }, rootElement);
        eventsHelper_1.default.live('.o-select-list, .js-select-list', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            _this.toggleSelectList(clickedElement, event);
        }, rootElement);
        eventsHelper_1.default.live('.o-select-list, .js-select-list', eventsHelper_1.default.keyDown, function (event, clickedElement) {
            // Space key
            if (event.keyCode == 32) {
                _this.toggleSelectList(clickedElement, event);
                event.stopPropagation();
                event.preventDefault();
                return false;
            }
            // Down key
            if (event.keyCode == 40) {
                var nextSibling = clickedElement.querySelector('.o-select-list__item--active').nextElementSibling;
                if (nextSibling) {
                    _this.selectOrDeselectItemsWithInput(nextSibling);
                }
                event.stopPropagation();
                event.preventDefault();
            }
            // Up key
            if (event.keyCode == 38) {
                var prevSibling = clickedElement.querySelector('.o-select-list__item--active').previousElementSibling;
                if (prevSibling) {
                    _this.selectOrDeselectItemsWithInput(prevSibling);
                }
                event.stopPropagation();
                event.preventDefault();
            }
            // Up key
            if (event.keyCode == 13) {
                _this.toggleSelectList(clickedElement, event);
                event.stopPropagation();
                event.preventDefault();
            }
        }, rootElement);
        // Click outside selectlist
        rootElement.addEventListener('click', function (event) {
            var clickedElement = event.target;
            var selectList = clickedElement.closest('.o-select-list, .js-select-list');
            if (!selectList) {
                var activeSelectLists = rootElement.querySelectorAll('.o-select-list.is-open, .js-select-list.is-open');
                if (activeSelectLists.length) {
                    for (var i = 0; i < activeSelectLists.length; i++) {
                        var activeElement = activeSelectLists[i];
                        if (activeElement.classList.contains('is-open')) {
                            activeElement.classList.remove('is-open');
                        }
                    }
                }
            }
        });
    }
    SelectList.prototype.toggleSelectList = function (clickedElement, event) {
        if (!clickedElement.classList.contains('is-open')) {
            this.rootElement.querySelectorAll('.o-select-list.is-open').forEach(function (item, index) {
                item.classList.remove('is-open');
            });
            clickedElement.classList.add('is-open');
        }
        else {
            var clickedInRowAndIsMultipleSelect_1 = clickedElement.classList.contains('o-select-list--multiple-select') && (event.target.closest('.o-select-list__item') != null || (event.path && Array.isArray(event.path) && event.path[0].closest('.o-select-list__item') != null));
            setTimeout(function () {
                if (!clickedInRowAndIsMultipleSelect_1) {
                    clickedElement.classList.remove('is-open');
                }
            }, 50);
        }
    };
    SelectList.prototype.selectOrDeselectItemsWithInput = function (clickedElement) {
        if (clickedElement === void 0) { clickedElement = null; }
        if (clickedElement) {
            var multipleSelect = clickedElement.closest('.o-select-list--multiple-select') != null;
            if (!multipleSelect) {
                var siblings = clickedElement.parentNode.querySelectorAll('.o-select-list__item');
                for (var i = 0; i < siblings.length; i++) {
                    siblings[i].classList.remove('o-select-list__item--active');
                }
                clickedElement.classList.add('o-select-list__item--active');
                var triggerPlaceholder = clickedElement.closest('.o-select-list').querySelector('.o-select-list__label');
                if (triggerPlaceholder) {
                    triggerPlaceholder.textContent = clickedElement.textContent;
                }
            }
        }
        var selectLists = this.rootElement.querySelectorAll('.o-select-list');
        selectLists.forEach(function (selectList) {
            var selectListItems = selectList.querySelectorAll('.o-select-list__item');
            var triggerPlaceholder = selectList.querySelector('.o-select-list__placeholder');
            var triggerPlaceholderText = '';
            selectListItems.forEach(function (selectListItem) {
                var selectListItemInput = selectListItem.querySelector('input');
                if (selectListItemInput) {
                    if (selectListItemInput.checked) {
                        selectListItem.classList.add('o-select-list__item--active');
                    }
                    else {
                        selectListItem.classList.remove('o-select-list__item--active');
                    }
                }
                if (selectListItem.classList.contains('o-select-list__item--active')) {
                    triggerPlaceholderText += (triggerPlaceholderText != '' ? ', ' : '') + selectListItem.textContent.replace(/\s+/g, " ").trim();
                }
            });
            // Set placeholder
            if (triggerPlaceholder) {
                triggerPlaceholder.textContent = triggerPlaceholderText != '' ? triggerPlaceholderText : triggerPlaceholder.dataset.placeholder;
            }
        });
    };
    return SelectList;
}());
exports.default = SelectList;
